module.exports = __webpack_public_path__ + "static/media/dinosaur(5).6ac076da.PNG";